export default __webpack_public_path__ + "static/media/IMG_5577.3b924959.jpg";